import React from "react";
import { BadgeCheck } from "lucide-react";
import { CIMA } from "@/lib/cima";
import InfraLogo from "@/components/cima/InfraLogo";

export default function LogoBanner() {
  return (
    <section
      data-testid="logo-banner"
      id="top"
      className="relative pt-24 lg:pt-28 pb-10 lg:pb-14 bg-white overflow-hidden border-b border-slate-200"
    >
      {/* Light metallic backdrop */}
      <div className="absolute inset-0 -z-10 metallic-surface" />
      <div className="absolute inset-0 -z-10 opacity-40">
        <div className="absolute -top-20 -left-20 w-72 h-72 stripe-accent rotate-12 logo-banner-stripe-left" />
        <div className="absolute -bottom-20 -right-20 w-72 h-72 stripe-accent -rotate-12 logo-banner-stripe-right" />
      </div>
      {/* Sweeping sheen */}
      <div className="absolute inset-0 -z-10 pointer-events-none logo-banner-sheen" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* SEO-only H1 — visually hidden but indexed by Google. Captures real search queries from Search Console. */}
        <h1 className="sr-only">
          Gas Zihuatanejo — CIMA Comercializadora Industrial Médica. Distribuidor
          Autorizado INFRA en Zihuatanejo de Azueta. Venta de gases industriales y
          medicinales, oxígeno, nitrógeno, argón, CO₂, acetileno, helio y
          soldadura. Renta y recarga de tanques de oxígeno a domicilio en
          Zihuatanejo, Ixtapa y la Costa Grande de Guerrero.
        </h1>
        <div className="relative flex flex-col items-center text-center">
          {/* Top accent line */}
          <div className="flex items-center gap-3 mb-5 logo-banner-rise">
            <span className="h-px w-12 bg-[var(--cima-orange)]" />
            <span className="font-mono-cima text-[10px] uppercase tracking-[0.35em] text-slate-600">
              Desde Zihuatanejo · Guerrero
            </span>
            <span className="h-px w-12 bg-[var(--cima-orange)]" />
          </div>

          {/* The logo */}
          <div className="relative inline-block logo-banner-logo">
            <img
              src={CIMA.logoUrl}
              alt="CIMA - Comercializadora Industrial Médica"
              className="h-32 sm:h-40 md:h-52 lg:h-64 w-auto object-contain drop-shadow-xl"
            />
            <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 h-1 w-2/3 bg-gradient-to-r from-transparent via-[var(--cima-red)] to-transparent logo-banner-underline" />
          </div>

          <p className="mt-7 font-display font-medium text-base sm:text-lg lg:text-xl text-slate-700 max-w-2xl logo-banner-tagline">
            Gases Industriales
            <span className="mx-3 text-[var(--cima-orange)]">·</span>
            Medicinales
            <span className="mx-3 text-[var(--cima-orange)]">·</span>
            Soldadura
            <span className="mx-3 text-[var(--cima-orange)]">·</span>
            Equipos Especializados
          </p>

          {/* INFRA Authorized Distributor badge — prominent under the CIMA logo */}
          <div
            data-testid="logo-banner-infra-badge"
            className="mt-7 inline-flex items-center gap-4 bg-white border border-slate-200 px-5 py-3 shadow-md"
          >
            <div className="flex items-center gap-2">
              <BadgeCheck className="w-5 h-5 text-[#E30613]" strokeWidth={2.2} />
              <div className="flex flex-col leading-tight text-left">
                <span className="font-mono-cima text-[9px] uppercase tracking-[0.3em] text-slate-500">
                  Distribuidor autorizado
                </span>
                <span className="font-display font-bold text-sm text-[var(--cima-navy)]">
                  Zihuatanejo · Costa Grande
                </span>
              </div>
            </div>
            <span className="h-9 w-px bg-slate-200" />
            <InfraLogo height={32} />
          </div>
        </div>
      </div>
    </section>
  );
}
